import React, { useEffect, useRef, useState } from "react";
import logo from "../../image/Salarytap_logo_horizontal-light_800X239_colored.jpg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import * as Yup from "yup";
import "./Login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import NavbarLogin from "./Navbar/Navbar";
import { APIURL } from "../../Config";

export default function CreateYourWorkspace() {
  const token = localStorage.getItem("token");
  const [show, setShow] = useState(true);
  const [isLoader, setIsLoader] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [paramsEmail, setParamsEmail] = useState("");
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [otpM, setOtpM] = useState(new Array(6).fill(""));
  const [mobileNo, setMobileNo] = useState("");
  const [otpError, setOtpError] = useState(null);
  const otpBoxReference = useRef([]);
  const otpBoxReferenceM = useRef([]);
  const history = useNavigate();

  const LoginSchema = Yup.object().shape({
    emailId: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    // mobileNo: Yup.string()
    //   .matches(/^[0-9]{10}$/, "Enter a valid 10-digit number")
    //   .required("Mobile number is required"),
  });

  const handleChange = (value, index, type) => {
    if (type === "E") {
      let newArr = [...otp];
      newArr[index] = value;
      setOtp(newArr);
      if (value && index < 5) otpBoxReference.current[index + 1].focus();
    } else if (type === "M") {
      let newArr = [...otpM];
      newArr[index] = value;
      setOtpM(newArr);
      if (value && index < 5) otpBoxReferenceM.current[index + 1].focus();
    }
  };

  const handleBackspaceAndEnter = (e, index, type) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      if (type === "E") otpBoxReference.current[index - 1].focus();
      else otpBoxReferenceM.current[index - 1].focus();
    }
    if (e.key === "Enter" && e.target.value && index < 5) {
      if (type === "E") otpBoxReference.current[index + 1].focus();
      else otpBoxReferenceM.current[index + 1].focus();
    }
  };

  const clearOtpFields = () => {
    setOtp(Array(6).fill(""));
    setOtpM(Array(6).fill(""));
    otpBoxReference.current[0]?.focus();
  };

  const handelSubmitOtp = async (emailOtp, mobileOtp) => {
    setIsLoader(true);
    const emailEmpty = emailOtp.some((value) => value === "");
    const mobileEmpty = mobileOtp.some((value) => value === "");

    if (!emailEmpty) {
      const dto = JSON.stringify({
        email: paramsEmail,
        otp: emailOtp.join(""),
        mobileotp: mobileOtp.join(""),
      });

      try {
        const response = await axios.request(`${APIURL}/corporate/otpverify`, {
          method: "POST",
          data: dto,
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        });

        setIsLoader(false);

        if (response?.data?.success) {
          clearOtpFields();
          history(
            `/salarytap/finalCreateYourWorkspace?token=${response?.data?.token}&email=${paramsEmail}`
          );
          toast.success("OTP verification successful");
        } else {
          toast.error("OTP verification failed");
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong!");
        setIsLoader(false);
      }
    } else {
      toast.error("All fields required");
      setIsLoader(false);
    }
  };

  const backToWeb = () => {
    history("/");
    localStorage.clear();
  };

  return (
    <>
      {show && (
        <Formik
          initialValues={{ emailId: "", mobileNo: "" }}
          validationSchema={LoginSchema}
          onSubmit={(values) => {
            const data = {
              email: values.emailId,
              mobileno: values.mobileNo,
              createflag: "create",
            };
            setMobileNo(values.mobileNo);
            setIsLoader(true);
            axios
              .request(`${APIURL}/corporate/login`, {
                method: "POST",
                data: data,
                headers: {
                  Authentication: token,
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                setIsLoader(false);
                setParamsEmail(response?.data?.emailId);
                if (response?.data?.workspaceId !== null) {
                  toast.warning("Workspace already created. Please login...");
                  history("/");
                  localStorage.clear();
                } else {
                  toast.success("OTP sent successfully");
                  setShow(false);
                  setShowOtp(true);
                }
              })
              .catch((error) => {
                setIsLoader(false);
                toast.warning("User does not exist...");
              });
          }}
        >
          {({ touched, errors }) => (
            <div className="Loginform-container">
              <Form className="Loginform">
                <div>
                  <button
                    className="btn btn-primary"
                    style={{ width: "100px" }}
                    onClick={() => history("/")}
                  >
                    Back
                  </button>
                </div>
                <div className="text-center mb-4">
                  <img src={logo} alt="logo" width="35%" height="100%" />
                </div>

                <div className="mb-4 text-center">
                  <span className="fs-5">
                    Hi, let us begin with your <b>email address</b>
                  </span>
                </div>
                <label className="fs-5 fw-medium">Enter your work email*</label>
                <Field
                  type="email"
                  name="emailId"
                  placeholder="Enter work email"
                  className={`form-control mt-2 ${
                    touched.emailId && errors.emailId ? "is-invalid" : ""
                  }`}
                />
                <ErrorMessage
                  component="div"
                  name="emailId"
                  className="invalid-feedback"
                />

                {/* <label className="fs-5 fw-medium mt-4">
                  Enter your mobile number*
                </label>
                <Field
                  type="number"
                  name="mobileNo"
                  placeholder="Enter mobile number"
                  className={`form-control mt-2 ${
                    touched.mobileNo && errors.mobileNo ? "is-invalid" : ""
                  }`}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                />
                <ErrorMessage
                  component="div"
                  name="mobileNo"
                  className="invalid-feedback"
                /> */}

                <button
                  type="submit"
                  className="btn btn-success mt-3"
                  style={{ backgroundColor: "#66a725" }}
                >
                  {isLoader ? (
                    <div
                      className="spinner-border text-light"
                      role="status"
                    ></div>
                  ) : (
                    "Continue"
                  )}
                </button>
              </Form>
            </div>
          )}
        </Formik>
      )}

      {showOtp && (
        <div className="Loginform-container">
          <div className="Loginform text-center">
            <img
              src={logo}
              alt="logo"
              width="35%"
              height="100%"
              className="mb-4"
            />
            <h5 className="fw-bold">Check your email for a code</h5>
            <p>Enter the OTP codes sent to your email </p>

            <label>Email OTP</label>
            <div className="d-flex justify-content-center mb-3">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  value={digit}
                  maxLength={1}
                  onChange={(e) => handleChange(e.target.value, index, "E")}
                  onKeyUp={(e) => handleBackspaceAndEnter(e, index, "E")}
                  ref={(ref) => (otpBoxReference.current[index] = ref)}
                  className="border text-center m-1"
                  style={{ width: "40px", height: "40px" }}
                />
              ))}
            </div>

            {/* <label>Mobile OTP</label>
            <div className="d-flex justify-content-center mb-4">
              {otpM.map((digit, index) => (
                <input
                  key={index}
                  value={digit}
                  maxLength={1}
                  onChange={(e) => handleChange(e.target.value, index, "M")}
                  onKeyUp={(e) => handleBackspaceAndEnter(e, index, "M")}
                  ref={(ref) => (otpBoxReferenceM.current[index] = ref)}
                  className="border text-center m-1"
                  style={{ width: "40px", height: "40px" }}
                />
              ))}
            </div> */}

            <button
              onClick={() => handelSubmitOtp(otp, otpM)}
              className="btn btn-success w-50"
              style={{ backgroundColor: "#66a725" }}
            >
              {isLoader ? (
                <div className="spinner-border text-light" role="status"></div>
              ) : (
                "Submit"
              )}
            </button>

            <div className="mt-3 text-end">
              <button
                className="btn btn-light"
                onClick={() => {
                  setShow(true);
                  setShowOtp(false);
                  clearOtpFields();
                }}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
